import { apiFetch } from './apiRequestHandler'
import { api_host } from '../constants'

export const getAssets = async (params = {}) => {
  const queryParams = new URLSearchParams(params).toString()
  const url = `${api_host}/assets/list${queryParams ? `?${queryParams}` : ''}`
  return await apiFetch(url)
}

export const uploadAsset = async (file, name) => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('name', name)

  const response = await fetch(`${api_host}/assets/upload`, {
    method: 'POST',
    credentials: 'include',
    body: formData
  })

  if (!response.ok) {
    const error = await response.json()
    throw new Error(error.error || 'Upload failed')
  }

  return await response.json()
}

export const deleteAsset = async (id) => {
  const url = `${api_host}/assets/${id}`
  return await apiFetch(url, { method: 'DELETE' })
}

export const getAsset = async (id) => {
  const url = `${api_host}/assets/${id}`
  return await apiFetch(url)
}

export const getAssetUrl = (s3Key) => {
  return `${api_host}/s3/${s3Key}`
}

export const getAssetVersions = async (id) => {
  const url = `${api_host}/assets/${id}/versions`
  return await apiFetch(url)
}

export const uploadAssetVersion = async (assetId, file = null, options = {}) => {
  const formData = new FormData()
  if (file) {
    formData.append('file', file)
  }
  if (options.name) {
    formData.append('name', options.name)
  }
  if (options.versionNote) {
    formData.append('versionNote', options.versionNote)
  }
  if (options.updateMetaOnly) {
    formData.append('updateMetaOnly', 'true')
  }

  const response = await fetch(`${api_host}/assets/${assetId}/version`, {
    method: 'POST',
    credentials: 'include',
    body: formData
  })

  if (!response.ok) {
    const error = await response.json().catch(() => ({}))
    throw new Error(error.error || 'Failed to upload new version')
  }

  return await response.json()
}

export const setAssetDefaultVersion = async (versionModelId, version) => {
  return await apiFetch(`${api_host}/assets/version-models/${versionModelId}/default`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ version })
  })
}

export const updateAssetVersionMeta = async (assetId, body) => {
  return await apiFetch(`${api_host}/assets/${assetId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  })
}

// Upload raw text content to a specific S3 key (overwrite existing)
export const uploadTextToKey = async (s3Key, content, contentType = 'text/plain') => {
  const blob = new Blob([content], { type: contentType })
  const file = new File([blob], s3Key.split('/').pop() || 'content.txt', { type: contentType })

  const formData = new FormData()
  formData.append('file', file)
  formData.append('key', s3Key)

  const response = await fetch(`${api_host}/upload-file`, {
    method: 'POST',
    credentials: 'include',
    body: formData
  })
  if (!response.ok) {
    const error = await response.text()
    throw new Error(error || 'Failed to upload content')
  }
  return await response.json()
}